import React, { useEffect, useRef, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import { useNavigate } from "react-router-dom";
import { useTranslation } from "react-i18next";
import { useAuth } from "../../context/AuthContext";
import { userSelector } from "../../store/selectors";
import ProfileSidebar from "../../components/ProfileSidebar/ProfileSidebar";
import emailjs from "@emailjs/browser";
import "./AgreementsScreen.css";
import ProfileMainIcon from "../../assets/profile-main.svg";
import TextField from "@mui/material/TextField";

import ProfileBillingIcon from "../../assets/profile-billing.svg";
import ProfileNotificationsIcon from "../../assets/profile-notifications.svg";
import ProfileSecurityIcon from "../../assets/profile-security.svg";
import ProfileTeamIcon from "../../assets/users.svg";
import ProfileActiveSessionsIcon from "../../assets/profile-active-sessions.svg";
import Avatar from "../../components/Avatar/Avatar";
import AppLogo from "../../assets/AppLogoBlue.svg";
import toast from "react-hot-toast";
import { deleteAgreement, fetchAgreements } from "../../store/usersSlice";

import { IconButton, InputAdornment } from "@mui/material";
import { Visibility, VisibilityOff } from "@mui/icons-material";
import NotificationsPopup from "../../components/NotificationsPopup/NotificationsPopup";
import ProfilePopup from "../../components/ProfilePopup/ProfilePopup";
import PrimaryButton from "../../components/PrimaryButton/PrimaryButton";
import InfoModal from "../../components/InfoModal/InfoModal";
import { ReactComponent as MenuIcon } from "../../assets/mobile/menu.svg";
import useIsMobile from "../../hooks/useIsMobile";
import AddAgreementModal from "../../components/AddAgreementModal/AddAgreementModal";

const AgreementsScreen = () => {
  const user = useSelector(userSelector);
  const navigate = useNavigate();
  const dispatch = useDispatch();
  const { t } = useTranslation();
  const isMobile = useIsMobile();
  const [isMenuOpen, setIsMenuOpen] = useState(false);
  const [addAgreementModalVisible, setAddAgreementModalVisible] =
    useState(false);
  const [agreementsArray, setAgreementsArray] = useState([]);

  useEffect(() => {
    updateAgreementsList();
  }, []);

  const updateAgreementsList = () => {
    dispatch(fetchAgreements()).then((res) => {
      if (!res.error) {
        setAgreementsArray(res.payload);
      }
    });
  };

  const inputFieldCx = {
    input: { color: "#F1F7FF" },
    display: "flex",
    width: isMobile ? "100%" : 403,
    fontSize: 15,
    borderRadius: 8,
    fontWeight: 500,
    backgroundColor: "#1f242e",
    // border: "1px solid #333b4b",
    borderRadius: "8px",
    "& .MuiInputBase-root.Mui-focused": {
      border: "1px solid #3496FF",
      borderRadius: "8px",
      boxSizing: "border-box",
    },
    "& .MuiInputBase-root": {
      border: "1px solid #333b4b",
      borderRadius: "8px",
      boxSizing: "border-box",
    },
    "& .MuiInputLabel-root": {
      color: "#717B8E",
    },
    "& .MuiInputLabel-root.Mui-focused": {
      color: "#3496FF",
    },
  };

  const handleDeleteDocument = (agreement) => {
    if (
      confirm(
        "Вы точно хотите удалить этот документ? Все его версии будут удалены"
      )
    ) {
      dispatch(deleteAgreement(agreement.id)).then((res) => {
        if (!res.error) {
          updateAgreementsList();
        }
      });
    }
  };

  const goToAgreement = (agreementId) => {
    navigate(`/profile/admin/agreements/${agreementId}`);
    return;
  };

  if (!user) return null;

  return (
    <div className={isMobile ? "App-mobile" : "App"}>
      {/* HEADER */}
      <div
        className={isMobile ? "mainScreenHeader-mobile" : "mainScreenHeader"}
      >
        <div className={isMobile ? "header-left-mobile" : "header-left"}>
          {isMobile && (
            <div
              onClick={() => setIsMenuOpen(!isMenuOpen)}
              style={{ display: "flex", marginTop: 7 }}
            >
              <MenuIcon color="white" />
            </div>
          )}
          <div
            onClick={() => navigate("/home", { replace: true })}
            className={"mainScreen-logoBlock"}
            style={{ cursor: "pointer" }}
          >
            <img src={AppLogo} style={{ height: "80%" }} alt="logo" />
          </div>
        </div>
        <div className="header-actions">
          <NotificationsPopup />
          <ProfilePopup />
        </div>
      </div>
      {/* LAYOUT: sidebar + main content */}
      <div className="support-container" style={{ alignItems: "flex-start" }}>
        {/* SIDEBAR */}
        {((!isMobile || isMenuOpen) && (
          <ProfileSidebar activeTab="admin" subActive="agreements" />
        )) ||
          null}
        {/* MAIN CONTENT */}
        <main className={isMobile ? "support-main-mobile" : "support-main"}>
          <div
            style={{
              display: "flex",
              flexDirection: "row",
              gap: 12,
              alignItems: "center",
              justifyContent: "flex-start",
            }}
          >
            {" "}
            <h1 className="support-title">Соглашения и документы</h1>
            <PrimaryButton
              style={{
                fontSize: 20,
                padding: 0,
                margin: 0,
                width: 30,
                height: 30,
              }}
              text="+"
              onClick={() => setAddAgreementModalVisible(true)}
            />
          </div>
          {agreementsArray.map((agreement) => (
            <div
              style={{
                width: "100%",
                height: 50,
                backgroundColor: "#1f242e",
                borderRadius: 15,
                padding: 15,
                paddingLeft: 25,
                paddingRight: 25,
                boxSizing: "border-box",
                color: "white",
                marginTop: 10,
                display: "flex",
                flexDirection: "row",
                alignItems: "center",
                justifyContent: "space-between",
                cursor: "pointer",
              }}
            >
              <span
                onClick={() => goToAgreement(agreement.id)}
                className="agreement-screen-item-title"
                style={{
                  fontSize: 16,
                  fontWeight: 600,
                  color: "#f1f7ff",
                }}
              >
                {agreement.name}
              </span>
              <span
                onClick={() => handleDeleteDocument(agreement)}
                className="agreement-screen-item-title"
                style={{
                  fontSize: 16,
                  fontWeight: 400,
                  color: "#f1f7ff",
                }}
              >
                Удалить
              </span>
            </div>
          ))}
        </main>
        {addAgreementModalVisible && (
          <AddAgreementModal
            isOpen={addAgreementModalVisible}
            onSuccess={() => {
              setAddAgreementModalVisible(false);
              updateAgreementsList();
            }}
            onClose={() => setAddAgreementModalVisible(false)}
          />
        )}
      </div>
    </div>
  );
};

export default AgreementsScreen;
